import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from '../../i18n';

const LABELS = { fr: "Français", en: 'English' };

/** Sélecteur de langue (liste déroulante français / anglais) ; le choix est mémorisé dans le navigateur. */
const LanguageSwitcher = ({ className = '' }) => {
    const { t, i18n } = useTranslation();
    const current = (i18n.language || 'en').slice(0, 2);

    return (
        <Dropdown className={className} alignRight>
            <Dropdown.Toggle variant="outline-secondary" size="sm" id="language-switcher" aria-label={t('Langue')}>
                <i className="fa fa-globe" /> {LABELS[current] || LABELS.en}
            </Dropdown.Toggle>
            <Dropdown.Menu>
                {SUPPORTED_LANGUAGES.map((language) => (
                    <Dropdown.Item
                        key={language}
                        as="button"
                        type="button"
                        active={current === language}
                        onClick={() => i18n.changeLanguage(language)}
                    >
                        {LABELS[language]}
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default LanguageSwitcher;
